<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <a
      class="text-hint"
      *ngIf="task.customerId || task.supplierId || task.employeeId"
    >
      <nb-icon
        icon="person-outline"
        [status]="
          task.objectType === 'customer'
            ? 'danger'
            : task.objectType === 'supplier'
            ? 'warning'
            : 'primary'
        "
      >
      </nb-icon>
      <span *ngIf="task.customerId">
        {{ task.customerName }}
      </span>
      <span *ngIf="task.supplierId">
        {{ task.supplierName }}
      </span>
      <span *ngIf="task.employeeId">
        {{ task.employeeName }}
      </span>
    </a>

    <button nbButton ghost (click)="cancel()" status="primary">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <ngx-view-working-task-card
      [workingTask]="task"
      class="card-item"
      [mode]="'customer'"
    ></ngx-view-working-task-card>
    <ngx-view-document
      *ngIf="task.description != ''"
      [content]="task.description"
    >
    </ngx-view-document>
  </nb-card-body>
</nb-card>
